module.exports = __webpack_public_path__ + "static/img01-961d737b5b3049ef4aaf099ebfd15a8c.jpg";